
import { Component, Vue } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import program_routes from "@/api/routes/programs";

import { normalizedProgramVersionStatusBadgeColor } from "@/helpers";

import { IProgram } from "@/models/program/program";

@Component({
  name: "CProgramListMethodical"
})
export default class CProgramListMethodical extends Vue {
  public normalizedProgramVersionStatusBadgeColor = normalizedProgramVersionStatusBadgeColor;

  public preload: boolean = false;

  public programs: IProgram[] = [];

  $refs!: {
    list: HTMLDivElement;
  };

  protected async created() {
    await this.loadPrograms();
  }

  private async loadPrograms() {
    this.preload = true;

    return this.$api
      .get(program_routes.index_methodical, {
        params: {
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: IProgram[] }) => {
        this.programs = res;
      })
      .finally(() => {
        this.preload = false;
      });
  }

  public scrollRight() {
    this.$refs.list.scrollLeft += 100;
  }

  public scrollLeft() {
    this.$refs.list.scrollLeft -= 100;
  }
}
